export const REQUEST_ACCOMMODATION_OPTIONS = [
  { value: 'yes', text: 'Yes' },
  { value: 'no', text: 'No' },
];

export const PREFERENCE_OPTIONS = [
  {
    value: 'veteran',
    text: 'Veteran or the unmarried spouse of a service person killed while in active service',
  },
  {
    value: 'fosterCare',
    text: 'Young adult transitioning out of foster care',
  },
  { value: 'involuntarilyDisplaced', text: 'Being involuntarily displaced' },
  { value: 'disability', text: 'Disability' },
  { value: 'elderly', text: 'Elderly' },
  { value: 'homeless', text: 'Homeless' },
  {
    value: 'rentBurden',
    text: 'Paying more than 50% of your income for rent',
  },
  { value: 'residency', text: 'Residency' },
  { value: 'victim', text: 'Victim' },
  { value: 'workingFamilies', text: 'Working families' },
];
